import { InputRadioGroup } from "@components-common/forms";
import {
  SelectSystemEnum,
  SelectSystemEnumProps,
} from "@components-common/forms";
import { wallLayerOptions } from "./types/wall-layer";

/**
 * Functional Component: WallLayerRadioSelector
 *
 * This component renders a radio button group for selecting the interior or exterior side of a wall layer.
 *
 * Props:
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.id - The ID for the radio group (default is "side").
 *
 * Returns:
 * @returns {JSX.Element} A JSX element containing the radio button group for selecting the wall layer side.
 */
export const WallLayerRadioSelector = ({
  id = "side",
  ...rest
}: { id: string } & any) => (
  <InputRadioGroup
    id={id}
    label="Interior/exterior"
    elementClass="mt-2 required"
    options={[
      { id: "interior", text: "Interior", value: "INTERIOR" },
      { id: "exterior", text: "Exterior", value: "EXTERIOR" },
    ]}
  />
);

/**
 * Functional Component: WallLayerSelector
 *
 * This component renders a dropdown selector for wall layers using the `SelectSystemEnum` component.
 *
 * Props:
 * @param {SelectSystemEnumProps} props - The properties passed to the component.
 * @param {string} [props.id="side"] - The ID for the dropdown selector (default is "side").
 *
 * Returns:
 * @returns {JSX.Element} A JSX element containing the dropdown selector for wall layers.
 */

export const WallLayerSelector = ({
  id = "side",
  ...rest
}: SelectSystemEnumProps) => (
  <SelectSystemEnum
    id={id}
    {...rest}
    options={wallLayerOptions}
    elementClass="required"
  />
);
